var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Surface',{class:[
    'table-row',
    _vm.disabled ? 'table-row--disabled' : '',
    _vm.clickable ? 'table-row--clickable' : ''
  ],attrs:{"component":"tr"},on:{"click":_vm.click}},[_vm._t("default"),(_vm.options)?_c('TableCell',{attrs:{"padding":"12px"}},[_c('div',{staticClass:"options"})]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }